import { useState, FormEvent } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { login } from '@/lib/auth'
import '../styles/Login.css'

export default function Login() {
  const navigate    = useNavigate()
  const [usuario, setUsuario]      = useState('')
  const [password, setPassword]   = useState('')
  const [erro, setErro]           = useState('')
  const [carregando, setCarregando] = useState(false)
  const [tentativas, setTentativas] = useState(0)
  const [showPass, setShowPass]   = useState(false)

  async function handleSubmit(e: FormEvent) {
    e.preventDefault()
    setErro('')
    setCarregando(true)

    try {
      await login(usuario.trim(), password)
      navigate('/acesso-restrito', { replace: true })
    } catch (err: unknown) {
      setTentativas(t => t + 1)
      const msg = err instanceof Error ? err.message : 'Erro ao fazer login.'

      if (msg.includes('429') || msg.toLowerCase().includes('bloqueado') || msg.toLowerCase().includes('muitas')) {
        setErro('Muitas tentativas de login. Aguarde 15 minutos antes de tentar novamente.')
      } else {
        setErro('Usuário, e-mail ou senha inválidos. Verifique suas credenciais.')
      }
    } finally {
      setCarregando(false)
    }
  }

  return (
    <div className="lg-page">

      {/* ══ PAINEL ESQUERDO — MARCA ══ */}
      <div className="lg-brand">
        <div className="lg-brand-grid" />

        <div className="lg-brand-logo">
          <Link to="/">
            <img src="/img/geral/logo-quantum-branca.png" alt="Sistema Quantum" />
          </Link>
        </div>

        <div className="lg-brand-body">
          <div className="lg-brand-badge">
            <i className="fa-solid fa-shield-halved" />
            Acesso Seguro
          </div>
          <h2 className="lg-brand-title">
            Área exclusiva para<br />
            <span>colaboradores</span>
          </h2>
          <p className="lg-brand-sub">
            Gerencie downloads, módulos e recursos do Sistema Quantum em um único lugar, com segurança e praticidade.
          </p>
        </div>

        <div className="lg-brand-footer">
          © {new Date().getFullYear()} Sistema Quantum. Todos os direitos reservados.
        </div>
      </div>

      {/* ══ PAINEL DIREITO — FORMULÁRIO ══ */}
      <div className="lg-panel">
        <div className="lg-form-wrap">

          <div className="lg-form-header">
            <div className="lg-form-icon">
              <i className="fa-solid fa-lock" />
            </div>
            <div className="lg-form-title">Acesso Restrito</div>
            <div className="lg-form-sub">Entre com suas credenciais para continuar.</div>
          </div>

          {/* Alertas */}
          {erro && (
            <div className="lg-alert lg-alert-error">
              <i className="fa-solid fa-circle-exclamation" />
              <span>{erro}</span>
            </div>
          )}
          {tentativas >= 3 && tentativas < 5 && !erro && (
            <div className="lg-alert lg-alert-warning">
              <i className="fa-solid fa-triangle-exclamation" />
              <span>
                Atenção: {5 - tentativas} tentativa{5 - tentativas !== 1 ? 's' : ''} restante{5 - tentativas !== 1 ? 's' : ''} antes do bloqueio temporário.
              </span>
            </div>
          )}

          <div className="lg-card">
            <form className="lg-form" onSubmit={handleSubmit} noValidate>
              <div className="lg-field">
                <label htmlFor="usuario" className="lg-label">Usuário ou E-mail</label>
                <input
                  id="usuario"
                  className="lg-input"
                  type="text"
                  autoComplete="username"
                  required
                  placeholder="usuário ou e-mail"
                  value={usuario}
                  onChange={e => setUsuario(e.target.value)}
                  disabled={carregando}
                />
              </div>

              <div className="lg-field">
                <label htmlFor="password" className="lg-label">Senha</label>
                <div className="lg-input-wrap">
                  <input
                    id="password"
                    className="lg-input"
                    type={showPass ? 'text' : 'password'}
                    autoComplete="current-password"
                    required
                    placeholder="••••••••"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    disabled={carregando}
                  />
                  <button
                    type="button"
                    className="lg-toggle-pass"
                    onClick={() => setShowPass(s => !s)}
                    tabIndex={-1}
                    aria-label={showPass ? 'Ocultar senha' : 'Mostrar senha'}
                  >
                    <i className={`fa-solid ${showPass ? 'fa-eye-slash' : 'fa-eye'}`} />
                  </button>
                </div>
              </div>

              <button
                type="submit"
                className="lg-btn-submit"
                disabled={carregando || !usuario || !password}
              >
                {carregando ? (
                  <><i className="fa-solid fa-circle-notch fa-spin" />Verificando...</>
                ) : (
                  <><i className="fa-solid fa-right-to-bracket" />Entrar</>
                )}
              </button>
            </form>
          </div>

          <div className="lg-links">
            <p className="lg-link-phone">
              Problemas com acesso?{' '}
              <a href="tel:+556332143357">(63) 3214-3357</a>
            </p>
            <Link to="/" className="lg-link-back">
              <i className="fa-solid fa-arrow-left" style={{ fontSize: '0.7rem' }} />
              Voltar ao site
            </Link>
          </div>

        </div>
      </div>

    </div>
  )
}
